import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
};

const PriceTagIcon = ({ color = '#0D84FE', size = 14, ...props }) => (
  <svg
    height={size}
    viewBox="0 0 25 26"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M24.831 5.286c0 3.776-1.646 6.518-1.715 6.633a.735.735 0 0 1-1.011.246.738.738 0 0 1-.25-1.013c.016-.025 1.502-2.521 1.502-5.866 0-1.907-1.24-3.291-2.95-3.291a2.952 2.952 0 0 0-2.95 2.95c0 .693.336 2.454.465 3.074a.738.738 0 0 1-1.444.302c-.05-.243-.497-2.405-.497-3.376A4.43 4.43 0 0 1 20.407.52c2.522 0 4.424 2.049 4.424 4.766zm-4.299 1.16c.293 2.451.718 7.226.23 7.712L10.047 24.874c-.658.66-1.728.66-2.388 0L.495 17.708a1.688 1.688 0 0 1 0-2.387L11.21 4.607c.17-.17 2.024-.178 4.108-.07-.011.138-.041.268-.041.408 0 .535.118 1.363.242 2.092a2.027 2.027 0 1 0 3.707 1.133 2.02 2.02 0 0 0-.871-1.662c-.108-.64-.194-1.26-.194-1.563 0-.065.013-.126.019-.19.257.027.51.055.749.084 1.416.174 1.43.172 1.603 1.608zm-5.711 8.02c-.166-.462-.443-1.017-1.044-1.655l.813-.815-.905-.904-.878.878c-1.175-.804-2.386-.739-3.208.083-.896.896-.684 2.033-.027 3.355.452.915.535 1.442.184 1.793-.36.36-.942.204-1.47-.323-.6-.6-.952-1.341-1.127-1.942l-1.359.806c.158.544.583 1.32 1.182 1.958l-.886.887.905.906.952-.952c1.257.886 2.524.767 3.346-.055.84-.843.915-1.785.194-3.282-.5-1.073-.62-1.6-.324-1.894.26-.26.721-.334 1.322.267.666.666.887 1.313 1.007 1.655l1.323-.766z"
      fill={color}
      fillRule="nonzero"
    />
  </svg>
);

PriceTagIcon.propTypes = propTypes;

export default PriceTagIcon;
